import {Stack} from "@mui/joy";
import {createFileRoute, useNavigate} from "@tanstack/react-router";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {validateAsofSearchParams} from "../../../tstzspan.ts";
import {useSurchargeAsof} from "../../../surcharge/surcharge.tsx";
import {SurchargeCargoView} from "../../../surcharge/cargo.tsx";
import {SurchargeableClassname} from "../../../rpc/webrpc-client.gen.ts";

function SurchargePage() {
    const {sc: inSubjectClass, id: surchargeId} = Route.useParams();
    const subjectClass = SurchargeableClassname.parse(inSubjectClass);
    const {asof} = Route.useSearch();
    const surchargeTqrv = useSurchargeAsof({subjectClass, surchargeId, asof});
    const isActive = surchargeTqrv.data?.isActive;
    const navigate = useNavigate();

    return <PageShell>
        <PageHeader>
            <Stack direction="column">
                <TopBar/>
            </Stack>
        </PageHeader>
        <PageBody>
            <SurchargeCargoView subjectClass={subjectClass} surchargeId={surchargeId} asof={asof}
                                onAsofChange={(newAsof) => {
                                    void navigate({
                                        to: Route.to, params: {sc: subjectClass, id: surchargeId}, search: {asof: newAsof},
                                    })
                                }}
                                active={!!isActive}/>
        </PageBody>
    </PageShell>;
}

function validateSearch(raw: Record<string, unknown>) {
    return {
        ...validateAsofSearchParams(raw),
    };
}

export const Route = createFileRoute("/_auth/surcharge/$sc/$id/cargo")({
    component: SurchargePage,
    validateSearch,
});

